<app-lms-modal-frame [title]="reportTitle" [pageHeadWidth]="600">
   <div modal-body class="p-0">
    <section class="loans-section container-fluid">

      <div class="table-panel">
        <div class="table-scroll-wrapper">
          <table class="loans-table" #TABLE>
            <caption>
              {{ reportTitle }}
              <span *ngIf="startDate && endDate"> &mdash; {{ startDate }} to {{ endDate }}</span>
            </caption>
            <thead class="sticky-thead">
              <tr>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">ID Number</th>
                <th scope="col">Branch Serial</th>
                <th scope="col">Client Number</th>
                <th scope="col">Loan Reference</th>
                <th scope="col">Status</th>
                <th scope="col">Created By</th>
                <th scope="col">Completed By</th>
                <th scope="col">Completed On</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of lmsDataReportlst | paginate: config">
                <td>{{ row.firstName }}</td>
                <td>{{ row.lastName }}</td>
                <td>{{ row.idNumber }}</td>
                <td>{{ row.branchSerial }}</td>
                <td>{{ row.clientNumber }}</td>
                <td>{{ row.loanReference }}</td>
                <td>{{ row.status }}</td>
                <td>{{ row.createdBy }}</td>
                <td>{{ row.updatedBy }}</td>
                <td>{{ row.updatedOn | date: 'yyyy-MM-dd HH:mm' }}</td>
              </tr>
              <tr *ngIf="lmsDataReportlst.length === 0">
                <td colspan="12" class="text-center text-muted py-3">No data available.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="paginator-row">
          <pagination-controls [id]="config.id || 'lms-data-report-pager'"
            (pageChange)="config.currentPage = $event"></pagination-controls>
        </div>
      </div>

      <div class="action-bar">
        <button class="btn-action btn-export" type="button" (click)="exportToExcel()">
          <i class="fas fa-file-excel fa-fw"></i> Export to Excel
        </button>
        <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
      </div>

    </section>
  </div>
</app-lms-modal-frame>
